<template>
  <q-page padding>
    <div class="fit row justify-between items-start">
      <div class="col-6">
        <p class="text-h5">Responder Controle Emocional</p>
      </div>
    </div>
    <q-card>
      <p class="row justify-center content-center text-h5 q-pt-md">
        Como estou me sentindo?
      </p>

      <q-separator />

      <q-card-section>
        <div class="row justify-end">
          <q-input
            class="col-xs-8 col-sm-3 col-lg-2"
            v-model="date"
            :readonly="true"
            borderless
          >
            <template v-slot:prepend>
              <q-icon name="event" />
            </template>
          </q-input>

          <q-input
            class="col-xs-4 col-sm-2 col-xs-2"
            v-model="horas"
            :readonly="true"
            borderless
          >
            <template v-slot:prepend>
              <q-icon name="schedule" />
            </template>
          </q-input>
        </div>
      </q-card-section>
      <div class="q-pa-md q-gutter-sm column justify-center">
        <q-btn
          class="b1"
          outline
          icon="sentiment_very_satisfied"
          color="green"
          label="Ótimo"
          size="xl"
          @click="setResposta(5)"
        />
        <q-btn
          outline
          class="b2"
          icon="sentiment_satisfied"
          color="blue"
          label="Bem"
          size="xl"
          @click="setResposta(4)"
        />
        <q-btn
          outline
          icon="sentiment_neutral"
          color="yellow-5"
          label="Regular"
          size="xl"
          @click="setResposta(3)"
        />
        <q-btn
          outline
          class="b3"
          icon="sentiment_dissatisfied"
          color="orange"
          label="Ruim"
          size="xl"
          @click="setResposta(2)"
        />
        <q-btn
          outline
          icon="sentiment_very_dissatisfied"
          color="red"
          label="Péssimo"
          size="xl"
          @click="setResposta(1)"
        />
      </div>
    </q-card>
    <modal-justificativa :resposta="resposta" :watch="watch" />
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";

import ModalJustificativa from "../components/ModalJustificativa.vue";
export default {
  components: {
    ModalJustificativa,
  },
  setup() {
    const date = ref("");
    const horas = ref("");
    const resposta = ref("");
    const watch = ref(0);

    const setResposta = async (value) => {
      resposta.value = value;
      watch.value++;
    };

    const getHours = async () => {
      let hours = new Date();
      let hora = hours.getHours();
      let min = hours.getMinutes();

      if (min.toString().length == 1) {
        min = `0${min}`;
      }
      horas.value = `${hora}:${min}`;
      setInterval(() => {
        getHours();
      }, 60000);
    };

    const getDate = async () => {
      const meses = [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro",
      ];
      let data = new Date();
      let dataFormatada =
        data.getDate() +
        " " +
        "de" +
        " " +
        meses[data.getMonth()] +
        " " +
        data.getFullYear();

      date.value = dataFormatada;
    };

    onMounted(getHours);
    onMounted(getDate);

    return {
      date,
      getDate,
      horas,
      getHours,
      setResposta,
      resposta,
      watch,
    };
  },
};
</script>

<style>
.b1 {
  padding-right: 50px;
}
.b2 {
  padding-right: 75px;
}
.b3 {
  padding-right: 69px;
}
</style>
